// extracted by mini-css-extract-plugin
export default {"galleryItem":"ImageGalleryItem_galleryItem__vbZf8"};